import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import Home from "@/pages/Home";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Editor from "@/pages/Editor";
import Beyond from "@/pages/Beyond";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.25 });
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalPost />} />
            <Route path="/editor" element={<Editor />} />
            <Route path="/beyond/:category" element={<Beyond />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
